import { useTableSearch } from "~/hooks/useTableSearch"
import { toLineSearchField, type LineSearchField, type LineSearchOption } from "~/utils/lineSearch"

export function useLineSearch<F extends LineSearchField = LineSearchField>(
  tableId: string,
  options: readonly LineSearchOption<F>[],
  defaultSearchBy: LineSearchField = "all",
) {
  const { searchText, setSearchText, searchBy, setSearchBy } = useTableSearch(
    tableId,
    defaultSearchBy,
  )
  return {
    search: searchText,
    setSearch: setSearchText,
    searchBy: toLineSearchField(searchBy, options),
    setSearchBy,
  }
}
